import { render } from "./Logistica.vue?vue&type=template&id=702e4b08&scoped=true"
import script from "./Logistica.vue?vue&type=script&lang=js"
export * from "./Logistica.vue?vue&type=script&lang=js"

import "./Logistica.vue?vue&type=style&index=0&id=702e4b08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702e4b08"]])

export default __exports__